import { render, staticRenderFns } from "./claimBatchStatus.vue?vue&type=template&id=0f548f59&"
import script from "./claimBatchStatus.vue?vue&type=script&lang=js&"
export * from "./claimBatchStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports